import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import Loading from '@/components/Core/Loading'
import Item from '@/components/ScreenConfigLayout/Item'
import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'

export default {
  name: 'ScreenConfigLayout',
  components: {
    Loading,
    Item
  },
  data () {
    return {
      loading: false,
      processing: false,

      displayHeight: 0
    }
  },
  mounted () {
    console.log('---------->>  /screenConfigMst/layoutConfig')
    $('body').addClass('unscroll')

    // resize
    $(window).on({ resize: this.onResize })
    this.$nextTick(this.onResize)

    // init
    this.init()
  },
  beforeDestroy () {
    $('body').removeClass('unscroll')

    // resize
    $(window).off({ resize: this.onResize })

    // reset
    this.reset()
  },
  computed: {
    ...mapState({
      // const
      moduleType: state => state.screenConfigLayoutConst.moduleType,
      // module
      active: state => state.screenConfigLayout.active,
      screenConfigMstUuid: state => state.screenConfigLayout.targetId,
      // model
      // configModel: state => state.screenConfigLayout.configModel,
      layoutModel: state => state.screenConfigLayout.layoutModel,
      // values
      values: state => state.screenConfigLayout.values,

      // confirm
      confirmKey: state => state.confirm.key,
      confirmAccepted: state => state.confirm.accept,

      // preset
      presetHeader: state => state.sclHeaderModule.preset,
      presetSlideShow: state => state.sclSlideShowModule.preset,
      presetWeather: state => state.sclWeatherModule.preset,
      presetFortune: state => state.sclFortuneModule.preset,
      presetCalender: state => state.sclCalenderModule.preset,
      presetButton: state => state.sclButtonModule.preset,
      presetList: state => state.sclListModule.preset,
      presetLabel: state => state.sclLabelModule.preset,
      presetImage: state => state.sclImageModule.preset,
      presetPanel: state => state.sclPanelModule.preset,
    }),
    ...mapGetters({

    }),

    serviceType() {
      console.log(this.layoutModel)
      return this.layoutModel.serviceTypeName
    },

    stageWidth () {
      // return this.layoutModel.screenOrientationKbn === 0
      //    ? this.layoutModel.screenWidth || 1280
      //    : this.layoutModel.screenHeight || 800
      return this.layoutModel.screenWidth || 1280
    },
    stageHeight () {
      // return this.layoutModel.screenOrientationKbn === 0
      //    ? this.layoutModel.screenHeight || 800
      //    : this.layoutModel.screenWidth || 1280
      return this.layoutModel.screenHeight || 800
    },

    title () {
      return this.layoutModel.screenConfigName
    },

    disablePostButton () {
      return this.values.length === 0
    }
  },
  watch: {
    '$route' () {
      // ルーティング変更時にコンポーネントを非表示
      this.hide()
    },
    active (to) {
      if (!to) {
        this.hide()
      }
    },
    values (to) {
      console.log('LAYER | ', to)
      // console.log(JSON.stringify(this.values))

      // モジュールの配置を計算してプレビュー枠の拡大
      this.$nextTick(() => {
        let height = this.stageHeight
        $('#sclBody').find('.item').each(function () {
          let y = Number($(this).css('top').split('px').join(''))
          let h = y + $(this).outerHeight()
          // console.log(h)
          height = Math.max(height, h)
        })
        this.displayHeight = height
      })
    },
    confirmAccepted: function (to) {
      console.log('confirmKey : ', this.confirmKey)
      // 登録
      if (this.confirmKey === 'scl_register') {
        if (to) this.postData()
      }
    }
  },
  methods: {
    ...mapActions({
      showError: 'error/show',
      showConfirm: 'confirm/show',
      showToast: 'toast/show',
      hide: 'screenConfigLayout/hide',
      loadModel: 'screenConfigLayout/loadModel',
      // module
      showHeaderModule: 'sclHeaderModule/show',
      showSlideshowModule: 'sclSlideshowModule/show',
      showWeatherModule: 'sclWeatherModule/show',
      showFortuneModule: 'sclFortuneModule/show',
      showCalenderModule: 'sclCalenderModule/show',
      showButtonModule: 'sclButtonModule/show',
      showListModule: 'sclListModule/show',
      showLabelModule: 'sclLabelModule/show',
      showImageModule: 'sclImageModule/show',
      showPanelModule: 'sclPanelModule/show',
      showZIndexModule: 'sclZIndexModule/show',
      // reset
      reset: 'screenConfigLayout/reset',
    }),

    onResize () {
      let windowHeight = window.innerHeight ?
        window.innerHeight : $(window).height()

      // bodyの高さ指定
      let y = $('#sclHeader').outerHeight() + $('#sclControl').outerHeight()
      let bodyH = windowHeight - y
      // console.log(h)
      $('#sclBody').height(bodyH)

      // // ステージを天地中央に
      // this.$nextTick(() => {
      //   let stageH = $('#sclBody .stage').outerHeight()
      //   let y2 = Math.floor((bodyH - stageH) / 2)
      //   $('#sclBody > .wrap').css({ paddingTop: y2 })
      // })
    },

    init () {
      this.displayHeight = this.stageHeight
      this.loading = true

      //
      // let screenConfigDetailParams = {
      //   screenConfigMstUuid: this.screenConfigMstUuid
      // }
      let screenConfigLayoutParams = {
        screenConfigMstUuid: this.screenConfigMstUuid
      }

      // データ読出し
      this.loadModel({
        // screenConfigDetailParams: screenConfigDetailParams,
        screenConfigLayoutParams: screenConfigLayoutParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
        })
        .catch(error => {
          this.showError(error || null)
        })
    },

    getDisabledControlButton (key) {
      switch (key) {
        case 'layoutHeader':
        case 'layoutWeather':
        case 'layoutFortune':
        case 'layoutCalendar':
        case 'layoutPanel':
          return this.values.findIndex(item => item.type === key) !== -1
        case 'zIndex':
          return !this.values.length
        default:
          return false
      }
    },

    addModule (key) {
      if (this.getDisabledControlButton(key)) return

      switch (key) {
        case 'layoutHeader':
          this.showHeaderModule()
          return
        case 'layoutSlideshow':
          this.showSlideshowModule()
          return
        case 'layoutWeather':
          this.showWeatherModule()
          return
        case 'layoutFortune':
          this.showFortuneModule()
          return
        case 'layoutCalendar':
          this.showCalenderModule()
          return
        case 'layoutButton':
          this.showButtonModule()
          return
        case 'layoutList':
          this.showListModule()
          return
        case 'layoutLabel':
          this.showLabelModule()
          return
        case 'layoutImage':
          this.showImageModule()
          return
        case 'layoutPanel':
          this.showPanelModule()
          return
        case 'zIndex':
          this.showZIndexModule()
          return
      }
    },

    confirmData() {
      this.showConfirm({
        key: 'scl_register',
        title: '',
        body: '「' + this.title + '」の画面レイアウトを登録しますか？',
        acceptLabel: '登録'
      })
    },
    postData () {
      // this.processing = true
      // console.log(this.isModify)

      // パラメータを生成
      let parameters = {
        screenConfigMstUuid: this.screenConfigMstUuid,
        request: {
          screenLayout: {}
        }
      }
      this.moduleType.forEach(type => {
        const data = this.values.filter(item => item.type === type.value)
        if (data.length) {
          let list = data.map(item => this.getJsonb(item))
          this.$set(parameters.request.screenLayout, type.value, list)
        }
      })
      console.log('register data', parameters)

      // 登録
      ApiManager.request(
        ['screenConfigMst'],
        ['v1ScreenConfigMstLayoutPut'],
        [parameters])
        .then(res => {
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            // toast
            this.showToast({
              title: '画面レイアウトの登録',
              body: '「' + this.title + '」の画面レイアウトを登録しました。'
            })

            this.closeModal()

          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          
        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })
    },
    getJsonb(data) {
      console.log('getJsonb', data.type);

      let jsonb = $.extend(true, {}, data)

      if (jsonb.type === 'layoutHeader') {
        if (jsonb.roundCornerFlg === 0) {
          jsonb.rectRoundCornerStyle = this.presetHeader.rectRoundCornerStyle
        }
      }

      if (jsonb.type === 'layoutButton') {
        if (jsonb.roundCornerFlg === 0) {
          jsonb.rectRoundCornerStyle = this.presetButton.rectRoundCornerStyle
        }
      }

      if (jsonb.type === 'layoutPanel') {
        if (jsonb.roundCornerFlg === 0) {
          jsonb.rectRoundCornerStyle = this.presetPanel.rectRoundCornerStyle
        }
      }

      delete jsonb.type
      return jsonb
    },
    
    /**
     * モーダルを閉じる
     */
    closeModal () {
      this.hide()
    }
  }
}